import {createStore, applyMiddleware} from 'redux';
// import {createLogger} from 'redux-logger';
import thunk from 'redux-thunk';

import reducers from '../reducers';
// import {UserAction} from '../actions';

export default function initStore() {
  // const middlewares = [thunk];
  // if (process.env.NODE_ENV !== 'production') {
  //   middleware.push(createLogger());
  // }

  const store = createStore(
    reducers,
    applyMiddleware(thunk),
    // Middleware will not be applied to this sample.
  );

  // store.dispatch(UserAction.getUser());
  // store.dispatch(UserAction.getUserExercises());

  return store;
}
